// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3i8hn","title":"styles_title__3KnpI"};